module.exports = __webpack_public_path__ + "files/valentin-vilsans.bdc4981085891f80a7ed397b9cad0395.pdf";